const safeParse = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

export const tenant = () => safeParse(localStorage.getItem('tenant'));
export const getCompanyById = (id) => tenant()?.companies?.filter(company => company._id === id)[0]
